<script setup lang="ts">
import { Enums } from "@/enums";
import { useFacade } from "@/facades";
import InvoiceStatusLargeBadge from "../badges/InvoiceStatusLargeBadge.vue";

const props = defineProps<{
    visualId: string;
    name: string | undefined;
    status: Enums.InvoiceStatusEnum.Values;
    dueDate: Date;
}>();

const f = useFacade();
</script>

<template>
    <div class="flex flex-col md:flex-row gap-2 md:gap-0 items-center justify-between border-t border-b px-2 py-4">
        <div class="flex flex-row items-center justify-center w-24 h-24">
            <img :src="`${f.env.assets}/logo`" />
        </div>
        <div class="flex flex-col items-center md:items-end gap-1">
            <div class="font-bold text-xl text-gray-500">{{ props.visualId }}</div>
            <div class="font-bold text-2xl">{{ props.name }}</div>
            <InvoiceStatusLargeBadge :dueDate="props.dueDate" :status="props.status" />
        </div>
    </div>
</template>
